import React from 'react';
import classNames from 'classnames';

import styles from './AskAiIcon.module.scss';

/** Figma S2_Icon_AIGenSearch_20_N (node 15445:111589) — 20×20 px */
export const ASK_AI_ICON_WIDTH_PX = 20;
export const ASK_AI_ICON_HEIGHT_PX = 20;

interface AskAiIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const AskAiIcon: React.FC<AskAiIconProps> = ({
  width = ASK_AI_ICON_WIDTH_PX,
  height = ASK_AI_ICON_HEIGHT_PX,
  className
}) => {
  return (
    <span className={classNames(styles.root, className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden
        focusable="false"
      >
        <path
          d="M18.78 17.72L13.447 12.387L13.444 12.385C13.581 12.215 13.718 12.045 13.84 11.861C14.069 11.515 13.974 11.05 13.629 10.822C13.284 10.593 12.819 10.687 12.589 11.033C11.566 12.578 9.85 13.501 8 13.501C4.967 13.501 2.5 11.033 2.5 8.00098C2.5 4.96898 4.967 2.50098 8 2.50098C8.149 2.50098 8.297 2.50698 8.443 2.51898C8.861 2.55198 9.218 2.24598 9.252 1.83298C9.286 1.41998 8.979 1.05798 8.566 1.02398C8.379 1.00798 8.191 1.00098 8 1.00098C4.14 1.00098 1 4.14198 1 8.00098C1 11.86 4.14 15.001 8 15.001C9.623 15.001 11.156 14.433 12.384 13.444C12.384 13.444 12.386 13.447 12.387 13.449L17.72 18.782C17.866 18.928 18.058 19.002 18.25 19.002C18.442 19.002 18.634 18.929 18.78 18.782C19.073 18.489 19.073 18.014 18.78 17.721V17.72Z"
          fill="currentColor"
        />
        <path
          d="M12.9405 9.58292C12.7465 9.58292 12.5505 9.53192 12.3725 9.42992C11.9445 9.18292 11.7265 8.69292 11.8305 8.20892L12.3435 5.83392L10.7125 4.03392C10.3805 3.66792 10.3235 3.13392 10.5705 2.70492C10.8185 2.27692 11.3075 2.05892 11.7925 2.16392L14.1665 2.67792L15.9655 1.04592C16.3325 0.713922 16.8665 0.655922 17.2955 0.903922C17.7235 1.15092 17.9415 1.64192 17.8365 2.12592L17.3235 4.49992L18.9545 6.29992C19.2865 6.66592 19.3445 7.19892 19.0965 7.62792C18.8495 8.05692 18.3605 8.27392 17.8745 8.16992L15.5005 7.65592L13.7015 9.28792C13.4865 9.48192 13.2145 9.58292 12.9405 9.58292ZM13.8495 5.96692L13.5375 7.41192L14.6325 6.41892C14.9045 6.17392 15.2765 6.07192 15.6345 6.15092L17.0775 6.46292L16.0855 5.36792C15.8405 5.09692 15.7405 4.72392 15.8165 4.36792L16.1285 2.92292L15.0335 3.91492C14.7625 4.15992 14.3895 4.26292 14.0305 4.18292L12.5875 3.87092L13.5795 4.96592C13.8245 5.23592 13.9255 5.61092 13.8475 5.96692H13.8495Z"
          fill="currentColor"
        />
        <path
          d="M7.39881 11.8117C7.26981 11.8117 7.14081 11.7787 7.02381 11.7107C6.74181 11.5477 6.59781 11.2217 6.66681 10.9027L6.86981 9.96374L6.22381 9.25275C6.00481 9.01174 5.96681 8.65574 6.12981 8.37374C6.29281 8.09174 6.61981 7.95174 6.93781 8.01574L7.87681 8.21874L8.58881 7.57274C8.83081 7.35274 9.18581 7.31574 9.46781 7.47874C9.74981 7.64174 9.89481 7.96774 9.82581 8.28674L9.62281 9.22574L10.2688 9.93774C10.4878 10.1797 10.5258 10.5347 10.3628 10.8167C10.2008 11.0987 9.87681 11.2427 9.55481 11.1747L8.61581 10.9717L7.90381 11.6167C7.76181 11.7447 7.58181 11.8107 7.40081 11.8107L7.39881 11.8117Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

export default AskAiIcon;
